import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'Pàgina no trobada',
  title: 'No hem trobat aquesta pàgina',
  body: 'Potser l\'enllaç està desfasat o la pàgina s\'ha retirat. Digueu-nos què busqueu i ho trobarem.',
  suggestionsTitle: 'Potser busqueu',
  bestMatchTitle: 'Volíeu dir',
  prefillHint: 'Emplenat a partir de l\'adreça que heu provat',
  goHome: 'Inici',
  browseAll: 'Totes les categories',
  reportBrokenLink: 'Informar d\'un enllaç trencat',
  noticeTitle: 'Aquesta pàgina no està disponible',
  noticeSearching: 'En lloc d\'això, cerquem {query}…',
  noticePrefilled: 'Cerqueu {query} aquí sota, o digueu-nos què busqueu.',
  errorTitle: 'Alguna cosa no ha funcionat',
  errorBody: 'No hem pogut carregar aquesta pàgina. Torneu-ho a provar, o cerqueu el que necessiteu aquí sota.',
  retry: 'Tornar-ho a provar',
  streamLostTitle: 'No hem pogut acabar aquesta pàgina',
  streamLostBody: 'La cerca s\'ha aturat abans de desar la pàgina. Torneu-la a començar i la reprendrem a partir de les vostres paraules.',
  relaunch: 'Tornar a cercar',
};
